module.exports = __webpack_public_path__ + "img/company_02.752baac0.png";